import type { SuppliersResponse } from 'api/models/Suppliers';
import ApiClientBase from './ApiClientBase';
//import axiosInstance from 'services/APIService';

class SuppliersEndpoint extends ApiClientBase {
  apiUri = '/api/v2/suppliers';

  getSuppliers() {
    return this.apiCall<SuppliersResponse>({ uri: '/', data: 'limit=-1' });
  }
}

const suppliers = new SuppliersEndpoint();
export default suppliers;
